import _ from 'lodash';
import React from 'react';

export enum RATE_LIMIT_TYPE {
    DEBOUNCE,
    THROTTLE,
}

/*
 * Return rate limited function with a debounce or throttle
 */
export function useRateLimitedCallback<TFunc extends (...args: any) => any>(
    callback: TFunc,
    rateLimitType: RATE_LIMIT_TYPE,
    rateLimitTypePeriodMs: number,
) {
    const callbackRateLimited = React.useMemo(() => {
        const rateLimitFn =
            rateLimitType === RATE_LIMIT_TYPE.DEBOUNCE
                ? _.debounce
                : _.throttle;
        return rateLimitFn(callback, rateLimitTypePeriodMs);
    }, [rateLimitType, rateLimitTypePeriodMs, callback]);

    return callbackRateLimited;
}
